require('./components/learn_activity.js');
require('./components/flash_cards.js');
require('./components/assignment.js');
require('./components/conjugator.js');
require('./components/quiz_controls');